import { stats } from "../../mock";

export const StatsBand = () => (
  <section data-testid="stats-band" className="border-y border-white/10 bg-[#0B1035]">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 grid grid-cols-2 lg:grid-cols-4 gap-8">
      {stats.map((s) => (
        <div key={s.label} data-testid={`stat-${s.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
          <p className="font-heading text-4xl sm:text-5xl font-medium text-white">{s.value}</p>
          <p className="mt-2 text-xs sm:text-sm text-slate-400 uppercase tracking-widest">{s.label}</p>
        </div>
      ))}
    </div>
  </section>
);
